import React, {useEffect, useState} from 'react';
import Header from "./Header";
import Footer from "./Footer";
import BackToTop from "../components/Switcher/BackToTop";

const Layout = ({children,pageName,text}) => {

    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 0) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return(
        <>
            <Header pageName={pageName} text={text} isScrolled={isScrolled}/>
                    <main className=''>
                        {children}
                    </main>
                <Footer/>
            {
                isScrolled ? <BackToTop /> : ""
            }
            </>
            )
      }

            export default Layout;